import React, { useEffect, useState } from 'react';
import { Table, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import Api from '../../util/api';
import t, { partial } from '../../util/translation/translation';
import useModal from '../../shared/hooks/useModal';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import Loading from '../../shared/components/custom/Loading';
import FormCard from '../../shared/components/custom/FormCard';
import SquareIconButton from '../../shared/components/custom/SquareIconButton';
import ApiKeyValue from '../../shared/components/custom/ApiKeyValue';

const CommunicationApiPage = () => {
  const [loading, setLoading] = useState(false);
  const [apiAccessList, setApiAccessList] = useState([]);
  const [handleModal, visible, deleteID] = useModal();
  const s = partial('shared');
  const p = partial('MessagesPage');

  const getApiAccess = async () => {
    setLoading(true);
    try {
      const accessList = await Api.userDevices.getApiAccesses();
      setApiAccessList(accessList || []);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      toast.error(t('api.404'));
    }
  };
  useEffect(() => {
    getApiAccess();
  }, []);
  const renderApiKeys = () =>
    apiAccessList.map((access) => (
      <tr key={`apiAccess-${access.id}`}>
        <td className="table-stack__primary">
          <strong className="font-weight-500">{access.entityName}</strong>
        </td>
        <td data-label={s('key')}>
          <ApiKeyValue apiKey={access.apiKey} id={`messages-${access.id}`} />
        </td>
        <td data-label={s('usage')}>
          {(access.requestsCount ?? 0).toLocaleString()}
        </td>
        <td className="table-stack__actions">
          <div className="icon-actions justify-content-end">
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              title={s('delete')}
              tone="danger"
              id={`delete-api-${access.id}`}
              onClick={() => handleModal(access.id)}
            />
          </div>
        </td>
      </tr>
    ));
  const deleteApiAccess = async () => {
    setLoading(true);
    try {
      await Api.userDevices.deleteApiAccess(deleteID);
      toast.success(s('deleteSuccessful'));
    } catch (err) {
      toast.error(t('api.404'));
    } finally {
      handleModal();
      getApiAccess();
    }
  };
  return (
    <>
      <Loading loading={loading} />
      <DeleteModal
        visible={visible}
        type={s('access')}
        handleModal={handleModal}
        modalAction={deleteApiAccess}
      />
      <FormCard
        title={
          <>
            API
            <span className="form-card__count">{apiAccessList.length}</span>
          </>
        }
        actions={
          <Link to="/messages_api/create">
            <Button color="primary" size="sm" className="mb-0">
              {s('create')} {s('key').toLowerCase()}
            </Button>
          </Link>
        }
        bodyClassName="form-card__body--flush"
        className="messages-settings__api"
      >
        <p className="form-card__intro">{p('apiKeysHint')}</p>
        <Table responsive striped className="table--roomy table--stack mb-0">
          <thead>
            <tr>
              <th>{s('companyName')}</th>
              <th>{s('key')}</th>
              <th>{s('usage')}</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {renderApiKeys()}
            {!loading && !apiAccessList.length && (
              <tr>
                <td colSpan={4} className="settings-empty">
                  {s('noApiKeys')}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </FormCard>
    </>
  );
};

export default CommunicationApiPage;
